"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    subPanelVariants: ()=>subPanelVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const subPanelSlots = {
    containerSlot: '',
    subPanelSlot: ''
};
const subPanelEmphasisVariants = {
    none: {
        subPanelSlot: ''
    },
    medium: {
        subPanelSlot: 'bg-primary-3'
    },
    bold: {
        subPanelSlot: 'bg-actionPrimary-8'
    }
};
const subPanelVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: subPanelSlots,
    variants: {
        position: {
            top: {
                containerSlot: 'flex justify-end',
                subPanelSlot: 'border-1 border-primary-5 mb-[-20px] rounded-t-lg px-2 pb-6 pt-1'
            },
            bottom: {
                containerSlot: 'flex justify-start',
                subPanelSlot: 'border-1 border-primary-5 mt-[-20px] rounded-b-lg px-2 pb-1 pt-6'
            }
        },
        emphasis: subPanelEmphasisVariants
    },
    defaultVariants: {
        position: 'top',
        emphasis: 'none'
    }
});
exports.subPanelVariants = __webpack_exports__.subPanelVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "subPanelVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
